export default (previousState = 0, { type, payload }) => {
    if (type === 'LOGGEDINUSER') {
        return payload.user
    }
    return previousState
}
